import type {
  CellRendererPlugin,
  EditorPlugin,
  FormatterPlugin,
  ValidatorPlugin,
} from "./types";

export class PluginRegistry {
  private cellRenderers = new Map<string, CellRendererPlugin>();
  private editors = new Map<string, EditorPlugin>();
  private formatters = new Map<string, FormatterPlugin>();
  private validators = new Map<string, ValidatorPlugin>();

  registerCellRenderer(plugin: CellRendererPlugin): void {
    this.cellRenderers.set(plugin.type, plugin);
  }

  registerEditor(plugin: EditorPlugin): void {
    this.editors.set(plugin.type, plugin);
  }

  registerFormatter(plugin: FormatterPlugin): void {
    this.formatters.set(plugin.type, plugin);
  }

  registerValidator(plugin: ValidatorPlugin): void {
    this.validators.set(plugin.name, plugin);
  }

  getCellRenderer(type: string): CellRendererPlugin | undefined {
    return this.cellRenderers.get(type);
  }

  getEditor(type: string): EditorPlugin | undefined {
    return this.editors.get(type);
  }

  getFormatter(type: string): FormatterPlugin | undefined {
    return this.formatters.get(type);
  }

  getValidator(name: string): ValidatorPlugin | undefined {
    return this.validators.get(name);
  }

  registerAll(plugins: {
    cellRenderers?: CellRendererPlugin[];
    editors?: EditorPlugin[];
    formatters?: FormatterPlugin[];
    validators?: ValidatorPlugin[];
  }): void {
    plugins.cellRenderers?.forEach((p) => this.registerCellRenderer(p));
    plugins.editors?.forEach((p) => this.registerEditor(p));
    plugins.formatters?.forEach((p) => this.registerFormatter(p));
    plugins.validators?.forEach((p) => this.registerValidator(p));
  }

  hasCellRenderer(type: string): boolean {
    return this.cellRenderers.has(type);
  }

  hasEditor(type: string): boolean {
    return this.editors.has(type);
  }
}
